import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { MyEInvoiceGenDocToIRBSubmissionQueueContainerModel } from '../../../../../models/aggregates/e-invoice/bl_fi_my_einvoice_gen_doc_to_irb_submission_queue_container.model';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { ApiVisa } from '../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../shared/api-response.model';


@Injectable({
  providedIn: 'root'
})

export class MyEInvoiceGenDocToIRBSubmissionQueueService extends BaseApiPublicLoginTemplateService<MyEInvoiceGenDocToIRBSubmissionQueueContainerModel, MyEInvoiceGenDocToIRBSubmissionQueueContainerModel, MyEInvoiceGenDocToIRBSubmissionQueueContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/gendoc-to-irb-submission-queues/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/gendoc-to-irb-submission-queues/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/gendoc-to-irb-submission-queues/backoffice-ep'
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/gendoc-to-irb-submission-queues/' + BaseApiTemplateService.LOGIN_EP
    this.httpClient = http;
  }

  postMultipleToProcess(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "e-invoice/gendoc-to-irb-submission-queues/submit-to-lhdn/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  getByCriteriaSubmissionResponse(criteria: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl =
        visa.api_domain_url +
        Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.ERP_PREFIX +
        'e-invoice/gendoc-to-irb-submission-queues/submission-response/backoffice-ep/query';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      criteria,
      this.getHttpHeader(visa)
    );
  }

}
